module.exports = __webpack_public_path__ + "static/chassis-card-8b0e353a420469aa0dec298270a85e0e.jpg";